import React from 'react'
import update from 'immutability-helper'
import moment from 'moment'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import NavLink from '../../Routes/NavLink'

import { financial } from '../../../core/controllers/Financial';
import { modal } from '../../../core/utilities/modal'

export default class FinancialBreakdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            type: props.data.type,
            transactions: null,
            getDataAgain: false,
            reloadData: false
        };

        financial.setType(props.data.type);

        this.index = 0;
    }

    componentDidMount() {
        // #  We need to setup our slimScroll on our editing window
		jQuery(jQuery('.single-task-card .scroll-attach')).slimScroll({
            height: '250px',
			alwaysVisible: true
        });

        this.reloadData();
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextState.getDataAgain) {
            this.reloadData();
            nextState.getDataAgain = false;
        } else if (nextState.reloadData) {
            nextState.reloadData = false;
        }
    }

    componentDidUpdate() {
        jQuery(jQuery('.single-task-card .scroll-attach')).slimScroll({
            height: '250px',
			alwaysVisible: true
        });
    }

    reloadData() {
        var self = this;
        financial.getTransactionHistory(function(response) {
            var transactions = [];
            response.data.forEach(transaction => {
                if(self.state.type == 'income') {
                    if(parseInt(transaction.history.charge) >= 0) {
                        transactions.push(transaction.history);
                    }
                } else if (self.state.type == 'netIncome') {
                    transactions.push(transaction.history);
                } else if (self.state.type == 'expenses') {
                    if(parseInt(transaction.history.charge) < 0) {
                        transactions.push(transaction.history);
                    }
                }
            });

            self.setState({
                transactions: transactions
            });
        });
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatPaymentDate(cell, row) {
        return moment(cell).format('MMM Do YYYY');
    }

     /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    formatAmount(value) {
        // format money
        var money = parseFloat(value);
        if(isNaN(money) || money === 0) {
            money = 0;
        } else {
            money = money / 100;
            money = Number(money.toFixed(2)).toLocaleString()
            money.toLocaleString("en-US", {style:"currency", currency:"USD"});
        }

        return money;
    }

    formatMoney(cell, row) {
        var money = this.formatAmount(cell);
        var cssClass = "positive";
        if(money < 0) {
            cssClass = "negative";
        }

        return "<span class='table-"+cssClass+"'>$"+money+"</span>";
    }

    render(){
        const transactions = this.state.transactions;
        const type = this.state.type;
        const isMinimized = this.props.isMinimized;
        var viewType = 'Gross Income';
        if(type == 'netIncome') {
            viewType = 'Net Income'
        } else if (type == 'expenses') {
            viewType = 'Expense';
        }
        if(!isMinimized) {
            return (
                <div class="card">
                    <div class="header">
                        <button type="button" aria-hidden="true" class="close" onClick={this.props.closeTask}>×</button>
                        <button type="button" aria-hidden="true" class="close minimize" onClick={this.props.minimizeTask}><i class="pe-7s-angle-down"></i></button>
                        <h4 class="title" onClick={this.props.minimizeTask}>Transactions For { moment().format('MMMM') }</h4>
                        <p class="category">{viewType}</p>
                    </div>
                    <div class="content">
                        <div class="scroll-attach">
                            <div class="row">
                                <div class="col-md-12">
                                {transactions != null && transactions.length != 0 && (
                                    <BootstrapTable data={transactions} version='4' striped search pagination>
                                        <TableHeaderColumn dataField='transaction_id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                        <TableHeaderColumn dataField='charge' dataFormat={this.formatMoney.bind(this)} dataSort={ true }>Charge</TableHeaderColumn>
                                        <TableHeaderColumn dataField='payment_date' dataFormat={this.formatPaymentDate} dataSort={ true }>Date</TableHeaderColumn>
                                    </BootstrapTable>
                                )}
                                </div>
                            </div>
                        </div>
                        <div class="footer">
                            <div class="legend">
                                <NavLink to="/financial">
                                    <button type="button" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill pull-right" autoComplete="off">
                                    Go To Financials
                                    </button>
                                </NavLink>
                                <div class="clearfix"></div>
                            </div>
                            <hr/>
                            <div class="stats">
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div class="card">
                    <div class="header">
                        <button type="button" aria-hidden="true" class="close" onClick={this.props.closeTask}>×</button>
                        <button type="button" aria-hidden="true" class="close minimize" onClick={this.props.maximizeTask}><i class="pe-7s-angle-up"></i></button>
                        <h4 class="title" onClick={this.props.maximizeTask}>Transactions For { moment().format('MMMM') }</h4>
                        <p class="category">{viewType}</p>
                    </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/components/MultiTaskManager/Type/FinancialBreakdown.jsx